import { VideoInputs } from './Video';

export const videoTransformer = (node: any): VideoInputs => {
    const video = node.relationships?.field_video;
    return {
        videoUrl: video?.field_media_oembed_video ?? video?.field_url_for_video,
        name: video?.name,
        title: node.field_component_title,
        caption: node.field_caption,
    };
};
